<template>
  <div class="py-4 px-4">
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h2 class="mb-0">{{ translatedLabel('formDrawerHeader', 'servicelibrary_Report') }}</h2>
      <button
        class="service-lib-round-btn no-outline d-flex justify-content-center align-items-center bg-transparent border-0 p-0 bg-gray-100"
        @click.prevent="close"
      >
        <b-icon icon="times" class="h3 mb-0" />
      </button>
    </div>
    <p class="mb-4">{{ translatedLabel('formDrawerDescription', 'servicelibrary_Report') }}</p>
    <ServiceLibraryErrorReportForm @onSubmitCallback="close" />
  </div>
</template>

<script>
import ServiceLibraryErrorReportForm from '@/components/ServiceLibrary/ServiceLibraryErrorReportForm'
export default {
  conceptName: ['ServiceLibrary'],
  components: {
    ServiceLibraryErrorReportForm
  },
  methods: {
    close() {
      this.$emit('handleVisibilityChange', false)
    }
  }
}
</script>
